<template>
  <div class="assignment-box">
    <slot/>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.assignment-box {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 32px 24px;
  margin-bottom: 24px;
}
</style>